module.exports = __webpack_public_path__ + "static/img/item-l_j_wildberry.7ff4acf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/item-l_j_wildberry.png
// module id = sc8a
// module chunks = 1